import http from "@/http-common"
import type { ICreateUserAction } from "@/types/Tracking.types"

class TrackingDataService {
  createUserAction(action: ICreateUserAction): Promise<any> {
    return http.post(`/auth/trackings/user-actions`, action)
  }
}

export default new TrackingDataService()
